;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { LoadingScreen } from 'src/deprecated/components/shared/LoadingScreen'
import {
  useAppRedirection,
  useAuthStatus,
} from 'src/deprecated/contexts/Authentication'
import { useUserContext } from 'src/deprecated/contexts/User'
import { useSlaEnforcement } from 'src/deprecated/hooks/utils/useSlaEnforcement'
import { PageOptions } from 'src/deprecated/types/next'
import { routes } from 'src/deprecated/utils/routes'

type AppAuthCheckerProps = {
  options?: PageOptions
  children: React.ReactElement
}

/**
 * @description Handle application after providers are loaded (as hook data is defined in providers)
 */
export function AppAuthChecker({
  options = {},
  children,
}: AppAuthCheckerProps) {
  const router = useRouter()
  const authState = useAuthStatus()
  const user = useUserContext()
  const { shouldEnforceSla } = useSlaEnforcement()

  const shouldRedirectToLogin = !options.public && authState === 'INVALID'
  const isWaitingAuthProvider = !options.public && authState === 'NOT_SET'
  const isWaitingUserProvider = !options.public && user === null

  const { onAppMount } = useAppRedirection(shouldRedirectToLogin)

  useEffect(() => onAppMount(), [onAppMount])

  const isVerifiedUser =
    user?.isPhoneVerified === true && user?.isEmailVerified === true

  const shouldRedirectToActivateAccount =
    !options.public &&
    !isWaitingUserProvider &&
    !isVerifiedUser &&
    !router.asPath.includes('activate-account')

  useEffect(() => {
    if (shouldRedirectToActivateAccount) {
      router.push(routes.activateAccount)
    }
  }, [shouldRedirectToActivateAccount, router])

  // SLA enforcement check - runs after authentication and verification checks
  const shouldRedirectToSlaAcceptance =
    !options.public &&
    !shouldRedirectToLogin &&
    !isWaitingAuthProvider &&
    !isWaitingUserProvider &&
    !shouldRedirectToActivateAccount &&
    shouldEnforceSla

  useEffect(() => {
    if (shouldRedirectToSlaAcceptance) {
      const targetReturnUrl = router.asPath
      const redirectParams = new URLSearchParams({
        redirectUrl: targetReturnUrl,
      })

      router.replace(`/legal/terms?${redirectParams}`)
    }
  }, [shouldRedirectToSlaAcceptance, router])

  const isAppLoading: boolean =
    isWaitingAuthProvider ||
    shouldRedirectToLogin ||
    isWaitingUserProvider ||
    shouldRedirectToActivateAccount ||
    shouldRedirectToSlaAcceptance

  if (isAppLoading) return <LoadingScreen />

  const pageNode = options.getLayout?.(children) || children

  return <>{pageNode}</>
}
